import classNames from 'classnames';
import React from 'react';
import getTopicPrivacyInfo from './getTopicPrivacyInfo';
import * as styles from './TopicIcon.module.scss';
import SVGIcon from '../components/SVGIcon';
import { gql } from '../graphql/generated';
import type { DocumentType } from '../graphql/generated';
import topicIcon from '../icons/prefilled/16x16/topic.svg';

const GET_TOPIC_ICON_TOPIC_FRAGMENT = gql(`
  fragment getTopicIcon_topic on Topic {
    id
    privacy
    memberEditable
  }
`);

const getTopicIcon = (
  topic: DocumentType<typeof GET_TOPIC_ICON_TOPIC_FRAGMENT>,
) => {
  const privacyInfo = getTopicPrivacyInfo(topic.privacy, topic.memberEditable);

  if (privacyInfo.isDefault) {
    return topicIcon;
  }

  return privacyInfo.icon;
};

interface TopicIconProps extends React.ComponentProps<typeof SVGIcon> {
  topic?: DocumentType<typeof GET_TOPIC_ICON_TOPIC_FRAGMENT>;
}

export const TopicIcon = ({ topic, ...props }: TopicIconProps) => (
  <SVGIcon {...props} className={classNames(styles.icon, props.className)}>
    {topic ? getTopicIcon(topic) : topicIcon}
  </SVGIcon>
);

export const TopicEntityIcon = () => (
  <div className={styles.container}>
    <TopicIcon />
  </div>
);
